
import React from 'react';
import { useTranslationUtils } from '@/hooks/useTranslationUtils';
import { Button } from '@/components/ui/button';
import { Sweepstakes } from '@/hooks/useSweepstakesData';

interface FormActionsProps {
  editingSweepstakes: Sweepstakes | null;
  resetForm: () => void;
}

const FormActions: React.FC<FormActionsProps> = ({ editingSweepstakes, resetForm }) => {
  const { t } = useTranslationUtils();

  return (
    <div className="flex justify-end space-x-4">
      <Button 
        type="button" 
        variant="outline" 
        onClick={resetForm}
      >
        {t('admin.cancel', 'Cancel')}
      </Button>
      <Button type="submit">
        {editingSweepstakes 
          ? t('admin.update', 'Update') 
          : t('admin.create', 'Create')}
      </Button>
    </div>
  );
};

export default FormActions;
